// Wikimedia Commons files are used only for banks whose identity is clear.
// Unknown institutions get a text badge instead of a misleading logo.
const files = [
  [/국민|KB/i, 'KB logo.svg'],
  [/신한/i, 'Shinhan Bank Logo (ENG).svg'],
  [/우리/i, 'Logo of Woori Bank.svg'],
  [/iM뱅크|대구은행|DGB/i, 'IM뱅크로고.png'],
];

export function bankLogo(name) {
  const file = files.find(([pattern]) => pattern.test(name || ''))?.[1];
  return file ? `https://commons.wikimedia.org/wiki/Special:FilePath/${encodeURIComponent(file)}?width=96` : null;
}

export function bankInitial(name) {
  return (name || '은행').replace(/은행|저축|지점|ATM|\s/g, '').slice(0, 2) || '은행';
}
